import React from 'react';
import { FileUploadService } from '../services/FileUploadService';

function FileUploadComponent({ 
  selectedFiles, 
  setSelectedFiles, 
  existingFiles, 
  folderName, 
  label = "Upload Files (Optional)",
  accept = "image/*,.pdf,.doc,.docx"
}) {
  
  const handleDownload = async () => {
    try {
      await FileUploadService.downloadFiles(folderName);
    } catch (error) {
      console.error('Download failed:', error);
      alert('Download failed');
    }
  };

  return (
    <div className="col-md-12 mb-3">
      <label className="form-label">{label}</label>
      <input
        type="file"
        className="form-control"
        multiple
        accept={accept}
        onChange={(e) => setSelectedFiles(Array.from(e.target.files))}
      />
      {selectedFiles.length > 0 && (
        <small className="text-muted">
          Selected: {selectedFiles.map(f => f.name).join(', ')}
        </small>
      )}
      {existingFiles && (
        <div className="mt-2">
          <small className="text-info d-block mb-2">Existing files:</small>
          <div className="table-responsive">
            <table className="table table-sm table-bordered">
              <thead>
                <tr>
                  <th>File Name</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {existingFiles.split(',').map((fileName, index) => (
                  <tr key={index}>
                    <td>{fileName.trim()}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-primary"
                        onClick={handleDownload}
                      >
                        <i className="fas fa-download"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default FileUploadComponent;